import React, { Component } from "react";
import {
	Card,
	CardHeader,
	CardBody,
	Row,
	Col,
	Table,
	Badge,
	Button,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import TableScrollbar from "react-table-scrollbar";
import moment from "moment";

import DefaultImg from "../../assets/images/product/Default_img.jpg";
import {
	getAuditQRowData,
	getAuditIGPListData,
	MaximizeWindow,
	MinimizeWindow,
	AuditPopRight,
	itemAuditApproval,
} from "../../store/Audit_Report/actions";
import Swal from "sweetalert2";

class PurchaseOrderCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			isAlertOpen: false,
			selectedItems: {},
			maximize: true,
		};

		this.tog_static = this.tog_static.bind(this);
	}

	tog_static(item) {
		this.setState((prevState) => ({
			modal_static: !prevState.modal_static,
			selectedItems: item,
		}));
		this.removeBodyCss();
	}
	maximizetogle() {
		this.setState((prevState) => ({
			maximize: !prevState.maximize,
		}));
	}
	removeBodyCss() {
		document.body.classList.add("no_padding");
	}
	callNextCard(id) {
		if (this.props.AuditData.length - 1 === this.props.index) {
			this.props.getAuditQRowData({
				ScreenID: id,
			});
			this.setState((prevState) => ({
				maximize: !prevState.maximize,
			}));
		}
	}
	callNextIGPListCard(id) {
		if (this.props.AuditData.length - 1 === this.props.index) {
			this.props.getAuditIGPListData({
				ScreenID: id,
			});
			this.setState((prevState) => ({
				maximize: !prevState.maximize,
			}));
		}
	}
	itemAuditApproved(item, auditStatus) {
		var data = {
			poauditstatus: auditStatus,
			purchaseorder_id: this.props.obj.data.id,
			poitem_id: item.id,
			// description:
		};

		if (item.poauditstatus === 1 || item.poauditstatus === 2) {
			Swal.fire({
				title: "Are you sure approve this item?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Approve",
			}).then((result) => {
				if (result.isConfirmed) {
					this.props.itemAuditApproval(data);
				}
			});
		}
	}

	render() {
		var obj = {};
		obj = this.props.obj;
		// var data = this.props.obj.data;
		// var loading = this.props.obj.loading;
		// var maximize = this.props.obj.maximize;

		return (
			<div className={this.state.maximize ? "maximize" : "minimize"}>
				<>
					<Row className="plaseholder">
						<Col md={12} className="p-1 W-100">
							<Card className="p-0 ">
								<CardHeader className="bg-transparent border-bottom ">
									<h5 className="card-title-18 pt-2 d-inline-block">
										PurchaseOrder (
										{this.props.obj.data.code})
									</h5>
									<div className="float-right">
										<Button
											type="button"
											color="secondary"
											className="waves-effect waves-light"
											onClick={() =>
												this.callNextIGPListCard(
													this.props.obj.data.id
												)
											}>
											Show IGP
											<i className="ml-2 mdi mdi-arrow-right"></i>
										</Button>
									</div>
								</CardHeader>
								<CardBody className="p-2 ">
									<Card className="p-1 m-0 ">
										<CardBody className="pt-1 pb-1">
											<Row className="p-0">
												<Col
													md={12}
													className="p-1 m-0">
													<div className="Indent-Request-panel-content">
														<div className="list-column">
															<Row>
																<Col md={6}>
																	<ul className="list-style-two p-0">
																		<li className="clearfix">
																			<span className="ttl">
																				Vendor
																				Name:
																			</span>
																			<span className="dtl">
																				{
																					obj
																						.data
																						.vendor
																						?.name
																				}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				Vendor
																				Location:
																			</span>
																			<span className="dtl">
																				{
																					obj
																						.data
																						.vendor
																						?.city
																				}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				Gross
																				Value:
																			</span>
																			<span className="dtl">
																				&#8377;{" "}
																				{
																					obj
																						.data
																						.total
																				}
																			</span>
																		</li>
																	</ul>
																</Col>
																<Col md={6}>
																	<ul className="list-style-two p-0">
																		<li className="clearfix">
																			<span className="ttl">
																				RFQ
																				No:
																			</span>
																			<span className="dtl">
																				{
																					obj
																						.data
																						.requestforquotation_code
																				}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				RFQ
																				Date:
																			</span>
																			<span className="dtl">
																				{moment(
																					obj
																						.data
																						.requestforquotation_date
																				).format(
																					"DD-MM-YYYY"
																				)}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				PO
																				Location:
																			</span>
																			<span className="dtl">
																				{
																					obj
																						.data
																						.location
																						?.name
																				}
																			</span>
																		</li>
																	</ul>
																</Col>
															</Row>
														</div>
													</div>
												</Col>
											</Row>
										</CardBody>
									</Card>

									<Row>
										<Col md={12} className="m-1">
											<div className="table-responsive m-1">
												<TableScrollbar height="400px">
													<Table className="mb-0 p-1 table-centered">
														<thead className="bg-light ">
															<tr>
																<th className="nowrap text-center">
																	S.No
																</th>
																<th className="nowrap text-center">
																	Item Images
																</th>
																<th
																	style={{
																		width: "320px",
																		minWidth:
																			"220px",
																	}}>
																	Item Name
																</th>
																<th className="nowrap text-center">
																	Quantity
																</th>
																<th className="nowrap text-center">
																	Item Base
																	Price
																</th>
																<th className="nowrap text-center">
																	Item
																	Discount(%)
																</th>
																<th className="nowrap text-center">
																	Item Price{" "}
																	<br />
																	(Discount)
																</th>
																<th className="nowrap text-center">
																	Tax Type(%)
																</th>
																<th className="nowrap text-center">
																	Tax Amount
																</th>
																<th className="nowrap text-center">
																	Gross Value
																</th>
																<th className="nowrap text-center">
																	Audit Status
																</th>
																{/* <th className="nowrap text-center">Action</th> */}
															</tr>
														</thead>
														<tbody>
															{obj.data.poitems?.map(
																(item, key) => (
																	<tr
																		key={
																			key
																		}>
																		<td className="nowrap text-center">
																			{key +
																				1}
																		</td>
																		<td className="nowrap text-center">
																			<div className="product-detail text-center">
																				<img
																					src={
																						item
																							?.product
																							?.image ==
																						null
																							? DefaultImg
																							: item
																									?.product
																									?.image
																					}
																					alt="product-img"
																					title="product-img"
																					className="product-img  img-fluid mx-auto tab-img rounded"
																					style={{
																						height: "100px",
																						width: "150px",
																					}}
																				/>
																			</div>
																		</td>
																		<td>
																			<h5 className="font-size-14">
																				<Link
																					to="#"
																					onClick={() =>
																						this.callNextCard(
																							obj
																								.data
																								.quotation
																						)
																					}
																					// onClick={() => this.tog_static(item)}
																					className="text-primary">
																					<u>
																						{
																							item
																								.product
																								.name
																						}
																					</u>
																				</Link>
																			</h5>
																			<p className="mb-0">
																				Make
																				:{" "}
																				<span className="font-weight-medium">
																					{
																						item.make
																					}
																				</span>
																			</p>
																			<p className="mb-0">
																				Description
																				:{" "}
																				<span className="font-weight-medium">
																					{
																						item.description
																					}
																				</span>
																			</p>
																			{item
																				.poi_acknowledges
																				.length !==
																				0 && (
																				<>
																					<p className="mb-0">
																						<b className="text-danger">
																							Acknowledge
																							:
																						</b>
																						<span className="font-weight-medium">
																							{
																								item
																									.poi_acknowledges[0]
																									.description
																							}
																						</span>
																					</p>
																					<p className="mb-0">
																						<b className="text-danger">
																							Acknowledge
																							By
																							:
																						</b>
																						<span className="font-weight-medium">
																							{
																								item
																									.poi_acknowledges[0]
																									.createdby
																									.fullname
																							}

																							(
																							{
																								item
																									.poi_acknowledges[0]
																									.createdby
																									.username
																							}

																							)
																						</span>
																					</p>
																				</>
																			)}
																		</td>
																		<td className="nowrap text-center">
																			{
																				item.qty
																			}
																		</td>
																		<td className="nowrap text-center">
																			{
																				item.baseprice
																			}
																		</td>
																		<td className="nowrap text-center">
																			{
																				item.discountpercent
																			}
																			%
																		</td>
																		<td className="nowrap text-center">
																			{
																				item.price
																			}{" "}
																			<br />
																			<sup>
																				({" "}
																				{
																					item.discount
																				}{" "}
																				)
																			</sup>
																		</td>
																		<td className="nowrap text-center">
																			{item.taxtype ===
																			1
																				? "Inclusive"
																				: item.taxtype ===
																				  2
																				? "Exclusive"
																				: ""}{" "}
																			(
																			{
																				item
																					.tax
																					.name
																			}
																			)
																		</td>
																		<td className="nowrap text-center">
																			{
																				item.taxamount
																			}
																		</td>
																		<td className="nowrap text-center">
																			&#8377;{" "}
																			{
																				item.gross
																			}
																		</td>
																		{/* <td className="nowrap text-center">
                                    {item?.poauditstatus_name}
                                  </td> */}
																		<td className="nowrap text-center">
																			{item.poauditstatus ===
																				3 && (
																				<Badge
																					className="font-size-14"
																					color="success">
																					{
																						item?.poauditstatus_name
																					}
																				</Badge>
																			)}
																			{(item.poauditstatus ===
																				1 ||
																				item.poauditstatus ===
																					2) && (
																				<Button
																					type="button"
																					color="primary"
																					className="waves-effect waves-light"
																					style={
																						item.poauditstatus ===
																							1 ||
																						item.poauditstatus ===
																							2
																							? {
																									display:
																										"show",
																							  }
																							: {
																									display:
																										"none",
																							  }
																					}
																					disabled={
																						item.poauditstatus ===
																						1
																							? false
																							: true
																					}
																					onClick={() =>
																						this.itemAuditApproved(
																							item,
																							3
																						)
																					}>
																					{/* <i className="mdi mdi-check"></i> */}
																					Approve
																					Audit
																				</Button>
																			)}
																		</td>
																	</tr>
																)
															)}
														</tbody>
													</Table>
												</TableScrollbar>
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>

					<Link
						to="#"
						className="strip"
						onClick={() => {
							this.maximizetogle();
							this.props.AuditPopRight(this.props.index);
						}}>
						<div className="MaximizeCard-item mb-2 ">
							<div className="MaximizeCard-title-box d-inline-block">
								<span className="mt-4">
									Purchase Order ({this.props.obj.data.code})
								</span>
							</div>
						</div>
					</Link>
				</>
			</div>
		);
	}
}
const mapStatetoProps = (state) => {
	const { AuditData } = state.AuditReport;
	return {
		AuditData,
	};
};

export default connect(mapStatetoProps, {
	getAuditQRowData,
	getAuditIGPListData,
	MaximizeWindow,
	MinimizeWindow,
	AuditPopRight,
	itemAuditApproval,
})(PurchaseOrderCard);
